import { createFileRoute, redirect } from '@tanstack/react-router'

import { AuthScreen, isAuthenticated, LoginForm } from '#/modules/auth'

function LoginPage() {
  return (
    <AuthScreen>
      <LoginForm />
    </AuthScreen>
  )
}

export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    // Signing in again while already signed in has no meaning — send them on.
    if (isAuthenticated()) {
      throw redirect({ to: '/' })
    }
  },
  component: LoginPage,
})
